import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import HomeHero from "../components/HomeHero";
import Footer from "../components/Footer";
import PageWrapper from "../components/PageWrapper";
import games, { featuredAppIds } from "../data/gamesData";
import { setPageMeta } from "../utils/pageMeta";
import "./Home.css";

const categorySections = [
  {
    titleKey: "pillar_games_title",
    examplesKey: "pillar_games_examples",
  },
  {
    titleKey: "pillar_utilities_title",
    examplesKey: "pillar_utilities_examples",
  },
  {
    titleKey: "pillar_health_title",
    examplesKey: "pillar_health_examples",
  },
];

export default function Home() {
  const { t } = useTranslation();

  useEffect(() => {
    setPageMeta({
      title: "MindBlows Studio",
      documentTitle: "MindBlows Studio",
      description: t("hero_subtitle"),
      image: "https://mindblows.com/assets/og-image.png",
      url: "https://mindblows.com/",
      robots: "index, follow",
    });
  }, [t]);

  const featuredApps = featuredAppIds
    .map((id) => games.find((app) => app.id === id))
    .filter(Boolean);

  return (
    <PageWrapper>
      <HomeHero />

      <main className="home-page">
        <section className="home-section">
          <div className="section-header">
            <h2>{t("featured_apps")}</h2>
            <Link to="/apps" className="section-link">
              {t("view_all_apps", { count: games.length })}
            </Link>
          </div>

          <div className="featured-grid">
            {featuredApps.map((app) => (
              <Link
                key={app.id}
                to={`/apps/${app.id}`}
                className="featured-card"
              >
                <img
                  src={app.icon}
                  alt={app.shortTitle}
                  className="featured-icon"
                />
                <div className="featured-info">
                  <h3>{app.title}</h3>
                  <span className="featured-category">
                    {t(app.categoryKey)}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </section>

        <section className="home-section">
          <h2 className="section-title-centered">{t("what_we_build")}</h2>
          <div className="category-grid">
            {categorySections.map((section) => (
              <div key={section.titleKey} className="category-card">
                <h3>{t(section.titleKey)}</h3>
                <p>{t(section.examplesKey)}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="home-section studio-stats">
          <div className="stat">
            <div className="stat-number">
              <CountUp end={2000000} duration={2.5} separator="," />+
            </div>
            <div className="stat-label">{t("downloads")}</div>
          </div>

          <div className="stat">
            <div className="stat-number">
              <CountUp end={games.length} duration={2} />+
            </div>
            <div className="stat-label">{t("apps_published")}</div>
          </div>

          <div className="stat">
            <div className="stat-number">4.5</div>
            <div className="stat-label">{t("avg_score")}</div>
          </div>
        </section>

        <section className="home-section home-about">
          <p>{t("home_about_snippet")}</p>
          <Link to="/about" className="home-about-link">
            {t("learn_more")} →
          </Link>
        </section>
      </main>

      <Footer />
    </PageWrapper>
  );
}
